import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { ModeEnum } from 'src/common/external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

import { dispatcherSlice } from '../dispatcher.slice';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

const modelOptions: SelectOption[] = [
  { label: 'Optimal', value: 'optimal' },
  { label: 'Non-Optimal', value: 'non-optimal' },
];

export const RunBambiRunModeSelect = () => {
  const dispatch = useAppDispatch();
  const { isBambi } = useUserRoles();

  const runBambiRunMode = useAppSelector(
    (state) => state.dispatcher.runBambiRunMode
  );

  if (!isBambi) {
    return null;
  }

  return (
    <DefaultFormFieldLayout
      label="Run Mode"
      helperText={{
        text: 'Optimal mode will prioritize efficiency. Non-optimal mode will schedule trips in a more human-like way.',
        presentation: {
          type: 'tooltip',
          position:
            'absolute left-1/2 top-full mt-1 w-[250px] -translate-x-1/2',
        },
      }}
    >
      <Select
        options={modelOptions}
        value={runBambiRunMode}
        onChange={(newValue) => {
          dispatch(
            dispatcherSlice.actions.setRunBambiRunMode(
              newValue?.value as ModeEnum
            )
          );
        }}
      />
    </DefaultFormFieldLayout>
  );
};
